import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import {HttpTransportType, HubConnection, HubConnectionBuilder, HubConnectionState} from '@microsoft/signalr'
import { ApplicationUserService } from 'src/app/core/services/application-user.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})


export class SignalRService {
  private readonly url = environment.baseUrlAddress;
  private connections: { [hubUrl: string]: HubConnection } = {};

  start(hubUrl: string): HubConnection {
    const userString = localStorage.getItem('currentUser');
    const branchString = localStorage.getItem('currentBranch');
    const currentUser = JSON.parse(userString);
    const currentBranch = JSON.parse(branchString);
    const token = currentUser?.token;
    if(!token) {
      console.warn('⚠️ No token found in currentUser. Cannot start SignalR connection.');
      return null;
    }
    const fullHubUrl = this.url + hubUrl + "?branchId=" + currentBranch?.id + "&access_token=" + token;

    // Eğer bağlantı zaten varsa tekrar başlatma.
    // Anahtar hubUrl: aşağıda da hubUrl ile saklanıyor. (Eskiden kontrol fullHubUrl ile
    // yapılıyordu ve her zaman ıskalıyordu; her start() yeni bir bağlantı açıyor, eskisi
    // açık kalıp aynı olayı tekrar tetikliyordu.)
    // Connecting/Reconnecting de "canlı" sayılır, yoksa el sıkışma sürerken gelen ikinci
    // çağrı yine kopya bağlantı açar.
    const existing = this.connections[hubUrl];
    if (existing && existing.state !== HubConnectionState.Disconnected) {
      return existing;
    }
    const builder: HubConnectionBuilder = new HubConnectionBuilder();
    const hubConnection: HubConnection = builder
      .withUrl(fullHubUrl, {
        /*
        accessTokenFactory: () => {
          const userString = localStorage.getItem('currentUser');

          if (!userString) {
            console.warn('⚠️ No currentUser found in localStorage.');
            return '';
          }

          try {
            const currentUser = JSON.parse(userString);
            const token = currentUser?.token;

            if (!token) {
              console.warn('⚠️ No token found in currentUser.');
              return '';
            }

            console.log(`🔗 Starting SignalR connection to ${fullHubUrl} with token ${token}`);
            return token;
          } catch (e) {
            console.error('❌ Failed to parse currentUser from localStorage', e);
            return '';
          }
        },

        headers:{
          'branchId': currentBranch?.id.toString() || '0'
        },
        */
        transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling | HttpTransportType.ServerSentEvents
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    hubConnection
      .start()
      .then(() => {
        console.log(`✅ SignalR connected to ${hubUrl}`)
      })
      .catch((error) => {
        console.warn(`❌ SignalR connection failed: ${error}`);
        setTimeout(() => this.start(hubUrl), 2000);
      });

    // if closed connection reconnected
    hubConnection.onreconnected(connectionId => console.log("Reconnected"));
    // if started to reconnection 
    hubConnection.onreconnecting(error => console.log("Reconnecting"));
    // if reconnection failed
    hubConnection.onclose(error => console.log("Close reconnection"));
    
    this.connections[hubUrl] = hubConnection;
    return hubConnection;
  }
  stop(hubUrl: string): void {
    const conn = this.connections[hubUrl];
    // Kaydı her hâlükârda düşür: aksi halde kapanmış bir bağlantı önbellekte kalır ve
    // sonraki start() onu canlı sanıp geri döner.
    delete this.connections[hubUrl];
    if (conn && conn.state !== signalR.HubConnectionState.Disconnected) {
      conn.stop().then(() => {
        console.log(`🛑 SignalR connection stopped: ${hubUrl}`);
      });
    }
  }
  // for trigger to other clients
  invoke(hubUrl: string, procedureName: string, message: any, successCallBack?: (value) => void, errorCallBack?: (error) => void) {
    this.start(hubUrl).invoke(procedureName, message)
      .then(successCallBack)
      .catch(errorCallBack);
  }

  // for listening 
  on(hubUrl: string, procedureName: string, callBack: (...message: any) => void) {
    this.start(hubUrl).on(procedureName, callBack);
  }
  

}